var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderImageSmall = function SvgPlaceholderImageSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 34h-31A1.5 1.5 0 0 1 0 32.5v-31A1.5 1.5 0 0 1 1.5 0h31A1.5 1.5 0 0 1 34 1.5v31a1.5 1.5 0 0 1-1.5 1.5ZM1.5 1a.5.5 0 0 0-.5.5v31a.5.5 0 0 0 .5.5h31a.5.5 0 0 0 .5-.5v-31a.5.5 0 0 0-.5-.5h-31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.94 33.85 10.3 15.14a.51.51 0 0 0-.71 0L.85 23.91l-.7-.7 8.73-8.78a1.54 1.54 0 0 1 2.13 0l18.64 18.72-.71.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.14 29.47 22.86 19.14a.51.51 0 0 0-.71 0l-3.55 3.57-.71-.71 3.55-3.56a1.53 1.53 0 0 1 2.12 0l10.29 10.33-.71.7ZM24.5 13a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v34H0z"
  })))));
};
export default SvgPlaceholderImageSmall;